<template>
  <div>
    <div class="invalid-goods-box">
      <div class="titleBox">
        <div class="title flex space-between">
          <span>以下商品已失效</span>
          <span
            v-show="!getManageBtnIsOpen"
            class="t_blue"
            @click="deleteInvalid('all')"
            >清空失效商品</span
          >
        </div>
        <div class="tip">
          <van-icon name="warning" class="icon" />商品失效30天后将会自动移除
        </div>
      </div>

      <!-- item list -->
      <van-checkbox-group
        v-model="getIneffectiveListInfo.chooseList"
        ref="checkboxGroup"
        @change="checkboxChange"
      >
        <div
          class="invalid-list-item"
          v-for="(item, index) in dataList"
          :key="index"
          @click="toggle(index)"
        >
          <div class="checkBoxBox" v-show="getManageBtnIsOpen">
            <van-checkbox :name="item.ProductId" ref="checkboxes" />
          </div>
          <!-- <span class="invalid-tag">失效</span> -->
          <div class="invalid-img"><img v-lazy="item.ShowPicUrl" alt="" /></div>
          <div class="invalid-info">
            <div class="info-title oneRow">
              <span class="invalid-tag">失效</span
              >{{ item.TitleShort || "----" }}
            </div>
            <p class="t_999">该商品已下架</p>
          </div>
          <!-- 删除按钮 -->
          <div
            v-show="!getManageBtnIsOpen"
            class="delete-icon"
            @click="deleteInvalid('single', item.ProductId)"
          >
            <i class="icon iconfont icon-garbage"></i>
          </div>
        </div>
      </van-checkbox-group>
    </div>
    <div class="invalid-btm-tip" v-show="!getManageBtnIsOpen">
      <span>别伤心~商品随时可能会回来哦！</span>
      <span class="tip-btn" @click="goHome">逛逛其它</span>
    </div>
  </div>
</template>

<script>
import { Icon, Checkbox, CheckboxGroup } from "vant";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "InvalidGoodsList",
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      "getManageBtnIsOpen",
      "getAllChooseBtnSwitchInfo",
      "getIneffectiveListInfo",
      "getAllListInfoStatus"
    ]),
  },
  components: {
    "van-icon": Icon,
    "van-checkbox": Checkbox,
    "van-checkbox-group": CheckboxGroup,
  },
  watch: {
    getAllChooseBtnSwitchInfo(val) {
      this.$nextTick(() => {
        if (val.allChoosedChangeNeedResetData) {
          this.toggleAll(val.allChoosedIsOpen);
        }
      })
    },
    dataList: {
      handler(val) {
        if (!this.getManageBtnIsOpen) return;
        if (this.getAllListInfoStatus) {
          let tempArr = [];
          val.forEach((val) => {
            tempArr.push(val.ProductId);
          });
          this.SET_INEFFECTIVE_LIST_INFO({
            allChoosed: true,
            chooseList: tempArr,
            dataListLength: val.length
          });
        }
      },
      // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
      immediate: true,
    },
  },
  props: {
    dataList: {
      type: Array,
      require: true,
      default() {
        return [];
      },
    },
  },
  methods: {
    ...mapMutations(["SET_INEFFECTIVE_LIST_INFO", "SET_ALL_CHOOSE_BTN_SWITCH_INFO"]),
    deleteInvalid(type, productId = null) {
      this.$emit("deleteInvalid", type, productId);
    },
    goHome() {
      this.$router.replace("souhuo");
    },
    toggleAll(val) {
      this.$refs.checkboxGroup.toggleAll(val);
    },
    toggle(index) {
      if (!this.getManageBtnIsOpen) return;
      this.$refs.checkboxes[index].toggle();
    },
    checkboxChange(val) {
      if (this.dataList.length <= 0 || !this.getManageBtnIsOpen) return
      let allChoosed = (val.length >= this.dataList.length)
      this.SET_INEFFECTIVE_LIST_INFO({
        allChoosed: allChoosed,
        chooseList: val,
        dataListLength: this.dataList.length
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.invalid-goods-box {
  margin-top: 1.5vh;
  padding: 0 3%;
  box-sizing: border-box;
  overflow: hidden;
  background: #fff;
  font-size: 14px;
  .titleBox {
    border-bottom: 1px solid #eee;
    padding: 8px;
    .title {
      align-items: center;
      cursor: pointer;
      margin-bottom: 8px;
    }
    .tip {
      display: flex;
      align-items: center;
      font-size: 13px;
      color: #b6b8ba;
      .icon {
        margin-right: 4px;
      }
    }
  }
}
.invalid-list-item {
  position: relative;
  display: flex;
  align-items: center;
  height: 95px;
  padding: 8px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
  overflow: hidden;
}
.invalid-list-item:last-child {
  border-bottom: none;
}
.invalid-tag {
  display: inline-block;
  color: #fff;
  background: #bcbcbc;
  flex-shrink: 0;
  border-radius: 3px;
  padding: 0 4px;
  margin-right: 4px;
  height: 18px;
  line-height: 18px;
  font-size: 14px;
}
.checkBoxBox {
  display: flex;
  align-items: center;
  // justify-content: space-around;
  width: 40px;
  flex-shrink: 0;
}
.invalid-img {
  flex-shrink: 0;
  height: 75px;
  width: 75px;
  margin-left: 10px;
}
.invalid-img img {
  height: 100%;
  width: 100%;
  border-radius: 4px;
}
.invalid-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 10px;
  height: 75px;
  margin-right: 30px;
}
.invalid-info .info-title {
  max-width: 100%;
  font-size: 14px;
}
.invalid-list-item .delete-icon {
  position: absolute;
  top: 2px;
  right: 0;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #999;
  border-radius: 50%;
}
.delete-icon:active {
  background: #f5f5f5;
}
.delete-icon .iconfont {
  font-size: 18px;
}
.invalid-btm-tip {
  height: 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 10px;
  color: #666;
  background: #fef4eb;
}
.invalid-btm-tip .tip-btn {
  height: 22px;
  line-height: 22px;
  padding: 2px 10px;
  border-radius: 15px;
  color: #f23030;
  border: 1px solid #f23030;
  cursor: pointer;
}
</style>
